export default __webpack_public_path__ + "static/catholicPensive-93d2fc0dc28458a010a5495a5a20b205.svg";